import { Component, Inject, Input, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SubscriptionPlansService } from '../../subscription-plans/subscription-plans.service';
import { environment } from 'src/environments/environment';

declare var Razorpay: any;


@Component({
  selector: 'hour4u-admin-upgrade-subscription-popup',
  templateUrl: './upgrade-subscription-popup.component.html',
  styleUrls: ['./upgrade-subscription-popup.component.scss']
})
export class UpgradeSubscriptionPopupComponent implements OnInit {
  currentPlan: string = 'FREE';
  selectedPlan: string | null = null;
  plans: any[] = [];
  isLoading: boolean;
  activeUpgradeIndex: number | null = null;

  constructor(private dialogRef: MatDialogRef<UpgradeSubscriptionPopupComponent>,
    public subscriptionPlansService: SubscriptionPlansService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private zone: NgZone
  ) { }

  ngOnInit() {
    console.log("Upgrade Subscription Popup Data", this.data);

    if (
      this.data &&
      this.data.currentPlan &&
      this.data.currentPlan.subscriptionStatus === 'SUBSCRIPTION_ACTIVE' &&
      this.data.currentPlan.subscriptionPlanName
    ) {
      this.currentPlan = this.data.currentPlan.subscriptionPlanName.toUpperCase();
    } else {
      this.currentPlan = 'FREE';
    }

    this.fetchAllSubscriptionPlans();
  }

  closePopup() {
    this.zone.run(() => {
      this.dialogRef.close(true);
    });
  }

  selectPlan(workflow: string) {
    console.log('Selected plan:', workflow);
    this.selectedPlan = this.selectedPlan === workflow ? null : workflow;
  }

  isSelected(plan: string): boolean {
    return this.selectedPlan === plan;
  }

  upgradePlan(plan: any, index: number): void {
    console.log('Upgrade button clicked for plan:', plan);
    this.activeUpgradeIndex = index;
    this.onUpgrade(plan);
  }

  // fetch all subscription plans
  fetchAllSubscriptionPlans() {
    this.subscriptionPlansService.fetchAllSubscriptionPlans().subscribe(
      (response: any) => {
        console.log("Plans", response);
        this.plans = response.filter((plan: any) => 
          plan.productType === 'HOA' && 
          plan.item.name.toLowerCase() !== 'starter'
        );
        // this.isFetching = false;
      },
      (error: any) => {
        console.log(error);
        // this.isFetching = false;
      }
    );
  }

  razorPayOptions = {
    key: '',
    subscription_id: '',
    description: 'HOA subscription plan payment',
    handler: (response) => {
      console.log(response)
      const subscriptionPaymentRequest = {
        razorpay_subscription_id: response.razorpay_subscription_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature
      };
      console.log("activating subscription", this.razorPayOptions.subscription_id);
      this.subscriptionPlansService.activateSubscription(this.razorPayOptions.subscription_id, subscriptionPaymentRequest).toPromise().then(res => {
        this.closePopup(); // close popup and indicate success
        // this.fetchAllSubscriptionPlans(); // or trigger success modal
      }).catch(err => {
        console.error("Activation failed", err);
      });
    }
  };

  onUpgrade(plan: any) {
    this.isLoading = true;
    const subscriptionData = {
      plan_id: plan.planId,
      total_count: 12,
      quantity: 1
    };
    this.subscriptionPlansService.sendRequestForSubscription(subscriptionData).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.activeUpgradeIndex = null;
        this.razorPayOptions.key = environment.rezorpayKey;
        this.razorPayOptions.subscription_id = response.subscriptionId;
        const rzp = new Razorpay(this.razorPayOptions);
        rzp.open();
        rzp.on('payment.failed', (resp) => {
          console.error("Payment failed", resp.error.reason);
        });
      },
      (error) => {
        console.error("Error in subscription request", error);
        this.activeUpgradeIndex = null;
      }
    );
  }

  contactSales() {
    console.log("Contact sales clicked");
    //window.location.href = 'mailto:hello@houseofagents.ai';
    window.open('https://wa.me/919818879566?text=Hello%20%I%20need%20help%20regarding%20my%20HOA%20account', '_blank');
  }

}